var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlbums(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 18H7C5.895 18 5 17.105 5 16V5C5 3.895 5.895 3 7 3H20C21.105 3 22 3.895 22 5V16C22 17.105 21.105 18 20 18Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.996 21.0004H4C2.895 21.0004 2 20.1054 2 19.0004V8.39941",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3457 6.82126C11.9967 7.47227 11.9967 8.52775 11.3457 9.17875C10.6947 9.82976 9.63925 9.82976 8.98825 9.17875C8.33725 8.52775 8.33725 7.47226 8.98825 6.82126C9.63926 6.17026 10.6947 6.17026 11.3457 6.82126",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 13.8334L18.614 11.1244C18.183 10.7794 17.553 10.8494 17.208 11.2804L14.636 14.4954C14.291 14.9264 13.662 14.9964 13.23 14.6514L11.931 13.6124C11.506 13.2724 10.887 13.3344 10.538 13.7534L7 18.0004",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbums);
export default __webpack_public_path__ + "static/media/albums.46d1adc4.svg";
export { ForwardRef as ReactComponent };